module.exports = __webpack_public_path__ + "static/media/art-theatre-music.265c20a1.webp";